import { render, staticRenderFns } from "./perubahan_fisik.vue?vue&type=template&id=3ca84fa2&"
import script from "./perubahan_fisik.vue?vue&type=script&lang=js&"
export * from "./perubahan_fisik.vue?vue&type=script&lang=js&"
import style0 from "./perubahan_fisik.vue?vue&type=style&index=0&id=3ca84fa2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports